function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "print_disabled",
  clipPath: "url(#clip0_2121_4972)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M7.05 8L0 15.05L25 40C16.7 40 10 46.7 10 55V85H30V105H90L104.75 119.8L111.8 112.75L7.05 8ZM30 75H20V55C20 52.25 22.25 50 25 50H35L50 65H30V75ZM40 95V75H60L80 95H40ZM40 25H80V40H53.3L63.3 50H95C97.75 50 100 52.25 100 55V75L90 75.05V65H78.3L98.3 85H110V55C110 46.7 103.3 40 95 40H90V15H30V16.8L40 26.8V25Z",
  fill: "#DCC6B7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M90 62.5508C92.7614 62.5508 95 60.3122 95 57.5508C95 54.7894 92.7614 52.5508 90 52.5508C87.2386 52.5508 85 54.7894 85 57.5508C85 60.3122 87.2386 62.5508 90 62.5508Z",
  fill: "#E26257"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2121_4972"
}, /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 120,
  fill: "white"
})));

function SvgPrintDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintDisabled);
export default __webpack_public_path__ + "static/media/print_disabled.31838bdf.svg";
export { ForwardRef as ReactComponent };